import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@solarwinds-cloud/cloud-ui';

const initESW = (gslbBaseURL, prepopulatedPrechatFields, chatParams) => {
  const {
    base_url,
    chat_url,
    entity_id,
    base_agent_domain,
    deployment_id,
    button_id,
    dev_name,
  } = chatParams;

  embedded_svc.settings.displayHelpButton = false;
  embedded_svc.settings.language = 'en-US';

  // Sets the domain so visitors can navigate subdomains during a chat session.
  embedded_svc.settings.storageDomain = 'papertrailapp.com';

  // Sets the auto-population of pre-chat form fields.
  embedded_svc.settings.prepopulatedPrechatFields = prepopulatedPrechatFields;

  embedded_svc.settings.enabledFeatures = ['LiveAgent'];
  embedded_svc.settings.entryFeature = 'LiveAgent';

  embedded_svc.init(
    base_url,
    chat_url,
    gslbBaseURL,
    entity_id,
    'TS_Papertrail_Chat',
    {
      baseLiveAgentContentURL: `https://c.${base_agent_domain}/content`,
      deploymentId: deployment_id,
      buttonId: button_id,
      baseLiveAgentURL: `https://d.${base_agent_domain}/chat`,
      eswLiveAgentDevName: dev_name,
      isOfflineSupportEnabled: false,
    }
  );
};

const init = (
  prepopulatedPrechatFields,
  setIsFallbackOpen,
  enableLiveChat,
  chatParams
) => {
  const { base_url } = chatParams;

  if (!window.embedded_svc) {
    var s = document.createElement('script');
    s.setAttribute('src', `${base_url}/embeddedservice/5.0/esw.min.js`);
    s.onload = function() {
      initESW(null, prepopulatedPrechatFields, chatParams);
    };
    document.body.appendChild(s);
  }

  const handleClick = () => {
    if (window.embedded_svc && !window.embedded_svc.isButtonDisabled) {
      window.embedded_svc.onHelpButtonClick();
    } else {
      setIsFallbackOpen(true);
    }
  };

  enableLiveChat(handleClick);

  return function cleanup() {
    enableLiveChat(null);
  };
};

export const ServiceCloud = (props) => {
  const { chatParams, company, email, enableLiveChat } = props;

  if (!chatParams.chat_url) {
    return null;
  }

  const prepopulatedPrechatFields = {
    Email: email,
    SuppliedEmail: email,
    SuppliedCompany: company,
  };

  const [isFallbackOpen, setIsFallbackOpen] = useState(false);
  useEffect(
    () =>
      init(
        prepopulatedPrechatFields,
        setIsFallbackOpen,
        enableLiveChat,
        chatParams
      ),
    []
  );

  return (
    <Modal
      closeIcon
      open={isFallbackOpen}
      size="mini"
      onClose={() => setIsFallbackOpen(false)}
    >
      <Modal.Header>Chat Offline</Modal.Header>
      <Modal.Content>
        <p>
          We’re here to answer any questions you have. Our team is available
          Monday - Friday from 9am - 5pm Central time.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <a
          className="btn-link mod-primary"
          href="mailto:technicalsupport@solarwinds.com"
        >
          Email Support
        </a>
      </Modal.Actions>
    </Modal>
  );
};

ServiceCloud.propTypes = {
  chatParams: PropTypes.object,
  company: PropTypes.string,
  email: PropTypes.string,
  enableLiveChat: PropTypes.func,
}
